module.exports = __webpack_public_path__ + "static/media/BASIS-WATERNIVEAU_05.6905a7ef.apng";